<template>
  <f7-page name="program-info">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        사용자 정보
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
		<div class="block block-strong text-align-center">						
			<div class="block-title text-align-right">
				<button class="button inline-btn" v-on:click="checkPasswrodDialog">정보수정</button>
			</div>
			<img src="static/imgs/user.png" style="height:160px;">
		</div>

		<f7-block-title>사용자 정보</f7-block-title>
		<div class="list">
			<ul>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">사용자 ID</div>
							<div class="item-after">{{userId()}}</div>
						</div>
					</div>
				</li>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">사용자 이름</div>
							<div class="item-after">{{userName()}}</div>
						</div>
					</div>
				</li>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">사용자 구분</div>
							<div class="item-after">{{userType()}}</div>
						</div>
					</div>
				</li>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">소속번호</div>
							<div class="item-after">CPK{{companyKey()}}</div>
						</div>
					</div>
				</li>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">사용자코드</div>
							<div class="item-after">{{userCode()}}</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
  </f7-page>
</template>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import AUTH from '../../../js/common/auth';

export default {
  data() {
    return {
      
    }
  },
  mounted() {

  },
  methods: {
		companyKey() {
			var userInfo = AUTH.getUserInfo();
			return userInfo.COMPANY_KEY;
		},
		userCode() {
			var userInfo = AUTH.getUserInfo();
			return CONST.userCodePrefix+userInfo.USER_CODE;
		},
		userKey() {
			var userInfo = AUTH.getUserInfo();
			return userInfo.USER_KEY;
		},
		userId() {
			var userInfo = AUTH.getUserInfo();
			return userInfo.USER_ID;
		},
		userName() {
			var userInfo = AUTH.getUserInfo();
			return userInfo.USER_NAME;
		},
		userType() {
			var userInfo = AUTH.getUserInfo();
			return userInfo.USER_TYPE;
		},
		checkPasswrodDialog(){
			const _this = this;			
			_this.$f7.dialog.password('','패스워드를 입력하세요.',function(password){
				_this.checkPasswrod(password);
			},null);
		},
		checkPasswrod(password){
			const _this = this;

			let param = {
				pPassword : password
			}
				
			API.ajaxRequest({
				url:API.checkPassword(),
				data: param
			}).then(function(data){
				if(_this.userType() == "student"){
					PAGES.editStudent(password);
				}else{
					PAGES.editTeacher(password);
				}
				
			}).catch(function(code){

				if (code == CONST.resultCode.NOT_EQUALS) {
					MODULE.DialogBox.message("에러", "패스워드가 틀리니다.");
					return;
				}

				MODULE.UITool.catchBlock(code,PAGES);

			});
			
		}
  }
}

</script>